var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complaints-filter-button",attrs:{"id":_vm.divid}},[_c('div',{staticClass:"cfd-btn"},[_c('btn',{staticClass:"btn-sm btn-link",class:{ hasFilter: _vm.hasFilter },attrs:{"title":"Filter"},on:{"click":_vm.openDialog}},[_c('symbol-filter',{attrs:{"SVGclass":_vm.hasFilter ? 'active' : ''}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }